import axios from 'axios'
import { getBpIdParam } from '../../common/helper'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'
import { trackFeatureAction } from '../../common/otel'

interface updateWhatsNewTourObj {
  component_id: string
  skip_count?: number
  current_step?: number
  is_dismissed?: boolean
}

const updateWhatsNewTour = async (whatsNewTourObj: updateWhatsNewTourObj) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('whatsnew_tour_update', 'attempt')
  try {
    const { data } = await axios.patch(
      `${buildURL('updateWhatsNewTour', apiConfig.whatsNewTour)}${bpIdParam}`,
      whatsNewTourObj,
    )
    trackFeatureAction('whatsnew_tour_update', 'success')
    return data
  } catch (error) {
    trackFeatureAction('whatsnew_tour_update', 'error')
    throw error
  }
}

export default updateWhatsNewTour
